import React, { lazy } from 'react';
import { PriceDisplay } from '../utils/currency';
export const Features = () => {
  return <section className="py-12 px-4 sm:px-6 md:px-8 max-w-7xl mx-auto" data-id="element-121">
      <h2 className="font-serif text-2xl sm:text-3xl font-bold text-center text-[#0C1B2A] mb-12" data-id="element-122">
        Lo que incluye tu guía
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-123">
        {/* Feature 1 */}
        <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-124">
          <div className="flex items-center mb-4" data-id="element-125">
            <div className="bg-[#F8F2EA] p-3 rounded-full mr-4" data-id="element-126">
              <svg className="w-6 h-6 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-127">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-128" />
              </svg>
            </div>
            <h3 className="font-serif text-xl font-semibold text-[#0C1B2A]" data-id="element-129">
              Plan de 7 días
            </h3>
          </div>
          <p className="text-[#555555]" data-id="element-130">
            Rituales diarios simples para realizar por la mañana y por la noche.
          </p>
        </div>
        {/* ... resto de features ... */}
        {/* Bonus Section */}
        <div className="bg-[#0C1B2A] p-6 rounded-lg shadow-md text-white" data-id="element-131">
          <div className="mb-4" data-id="element-132">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sVs3zw2j95VjC1x5Gaj6GW/ChatGPT_Image_12_sept_2025%2C_05_42_15_p.m..png" alt="5 Bonos especiales: libros de protección espiritual" className="w-full h-auto rounded-lg mb-4" loading="lazy" width="400" height="267" data-id="element-133" />
          </div>
          <div className="flex items-center mb-4" data-id="element-134">
            <div className="bg-[#D4AF37] p-3 rounded-full mr-4" data-id="element-135">
              <svg className="w-6 h-6 text-[#0C1B2A]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-136">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" data-id="element-137" />
              </svg>
            </div>
            <h3 className="font-serif text-xl font-semibold" data-id="element-138">
              <svg className="inline-block w-5 h-5 text-[#D4AF37] mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-139">
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#D4AF37" fillOpacity="0.2" stroke="#D4AF37" strokeWidth="2" data-id="element-140" />
                <path d="M8 12H16" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-141" />
                <path d="M12 8V16" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-142" />
              </svg>
              5 Bonos especiales
            </h3>
          </div>
          <ul className="space-y-2 mb-4" data-id="element-143">{/* ... lista de bonos ... */}</ul>
          <div data-id="element-144">
            <a href="#checkout" className="inline-block bg-[#D4AF37] hover:bg-[#C5A028] text-[#0C1B2A] font-bold py-2 px-6 rounded-lg transition-colors duration-300 mt-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D4AF37] focus:ring-offset-[#0C1B2A] mb-2" aria-label="Quiero la Guía" data-id="element-145">
              Quiero la Guía
            </a>
            <div className="mt-3 text-sm" data-id="element-146">
              <span className="text-white/70 line-through" data-id="element-147">Antes: $45.99</span>{' '}
              <span className="text-green-400 font-bold" data-id="element-148">Ahorro $34</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};